import React from 'react'
import { useStore } from '../../store'
import { getCdnAssetUrl } from '../../helpers/assets'

function VendorLogo({ className = '', src }) {
  const { data } = useStore()

  const logoPath = src || data?.selectedPackage?.vendor.logo_path

  return (
    <>
      {logoPath && (
        <img src={getCdnAssetUrl(logoPath)} alt={data?.selectedPackage?.vendor.display_name} className={`h-[32px] ${className}`} />
      )}
    </>
  )
}

export default VendorLogo
